import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import LoadingPage from '@/components/common/LoadingPage';
import { useFees } from '@/data/fee';
import { useRegions } from '@/data/region';
import FeeList from './components/FeeList';
import AddFeeDialog from './components/AddFeeDialog';
import FeeBreakdown from './components/FeeBreakdown';

const FeeEditPage = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex justify-between items-center mb-4">
          Global Rates / Fees <AddFeeDialog />
        </CardTitle>
        <CardDescription>
          Edit the global rates for ProFound, including platform fees and
          payment processing fees.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <FeeList />
        <FeeBreakdown />
      </CardContent>
    </Card>
  );
};

const FeeEditPageLoader = () => {
  const fees = useFees();
  const regions = useRegions();

  if (fees.isLoading && !fees.data) {
    return <LoadingPage />;
  }

  if (regions.isLoading && !regions.data) {
    return <LoadingPage />;
  }

  return <FeeEditPage />;
};

export default FeeEditPageLoader;
